'use strict';

/* jshint -W098 */
angular.module('mean.accounts-receivable').controller('BillingSetupController', ['$scope', '$rootScope', '$location', 'Global', 'MeanUser', 'toaster', '$filter', 'taskListService', 'ngDialog', 'tradeCodeService', 'TradeDrawService', 'BillingSettings', 'Trades', 'Projects', 'Options', 'aceUtils',
  function($scope, $rootScope, $location, Global, MeanUser, toaster, $filter, taskListService, ngDialog, tradeCodeService, TradeDrawService, BillingSettings, Trades, Projects, Options, aceUtils) {
    var vm = this;

    console.log('BillingInvoiceController');
    vm.state = $location.state();
    console.log(vm.state);

    if(!vm.state) {
        $location.url('/');
        return;
    }

    vm.user = MeanUser.user;
    vm.trade_code = tradeCodeService.getCode(vm.user.trade[0]);
    vm.trade_draw_data = [];
    vm.settings = TradeDrawService.getSettings();
    vm.options_need_updating = false;
    vm.task_list = null;
    vm.selection = null;
    vm.vp_items = ['P', 'V'];
    vm.vp_names = ['Percentage', 'Variable'];
    vm.vp_selection = vm.vp_names[0];
    vm.revisions = [];
    vm.editEmailIndex = -1;
    vm.editEmailText = null;
    //vm.company_emails = $scope.getCompanyEmails();

    vm.current_project_settings = null;
    vm.setCurrentProject = function() {
        _.each(vm.settings.builders, function(builder) {
            _.each(builder.projects, function(project) {
                if(project.job_code === vm.state.job_code) {
                    vm.current_project_settings = project
                }
            });
        });
    };

    var runSetup = function() {
        vm.setCurrentProject();

        Projects.query({'type': 'getProjectForJobCode', 
            'company_code': vm.state.company_code, 
            'trade_code': vm.state.trade_code, 
            'job_code': vm.state.job_code}, function(ret_data) {
            vm.project = ret_data[0];

            var trade = $filter('filter')(vm.project.trades, {'name': vm.user.trade[0]}, true);

            if(trade.length != 1) {
                toaster.pop('error', 'Project Trade Error', 'could not find the trade ' + 
                    vm.user.trade[0] + ' for this project. Contact admin.');
                return;
            }

            vm.revisions.push({
                'name': 'Current',
                'number': 0
            });
            _.each(trade[0].revisions, function(revision) {
                vm.revisions.push({
                    'name': 'Rev: ' + revision.number,
                    'number': revision.number
                });
            });

            vm.revisions.number = vm.revisions.length;

            Options.query({'project_id': vm.project._id}, function(ret_opts) {
                vm.project_options = ret_opts[0];

                if(vm.project_options) {
                    if(!vm.current_project_settings ||
                        vm.current_project_settings.options.length !== 
                        vm.project_options.options.length) {
                        vm.options_need_updating = true;
                    }
                }

                taskListService.getByTradeName(vm.user.trade[0], vm.project, vm.state.userId).then(function(list) {
                    if(list.length == 0)
                        toaster.pop('error', 'Task List Database Error', 'The requested list is not available.');
                    vm.task_list = list;
                    vm.selection = vm.task_list[0];
                    vm.task_list_codes = [];
                    _.each(vm.task_list, function(item) {
                        vm.task_list_codes.push(item.task_code);
                    });
                });
            });
        });

        if(!vm.settings.builders) {
            $location.url('/');
            return;
        }
    }

    runSetup();

    TradeDrawService.getBuilder(
        vm.state.trade_code, vm.state.company_code, vm.state.selection).then(function(ret_data) {
        vm.builder = ret_data;
        vm.trade_draw_data = TradeDrawService.getProjectDraws(vm.state.builder_name,
            vm.state.trade_code, vm.state.company_code, vm.state.job_code);
    });

    vm.onTaskSelectionChange = function(selection) {
        console.log(vm);
        console.log(selection);
        selection.name = selection.task_name;
    };
    
    vm.addDraw = function() {
        if(vm.task_list.length == 0) {
            toaster.pop('error', 'Draw Creation Error', 'Draws cannot be created due to a general task list error.');
            return;
        }
        vm.selection.name = vm.task_list[0].task_name;
        vm.selection_percentage = 0.0;
        ngDialog.openConfirm({
            template: 'accounts-receivable/views/setup/task_selection.html',
            data: {
                vm: vm
            },
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            console.log(this);
            //console.log(ngDialogData);
            console.log(vm);
            if(vm.vp_selection === 'Percentage') {
                vm.selection.v_or_p = 'P';
            } else {
                vm.selection.v_or_p = 'V';
            }

            vm.selection.percentage = vm.selection_percentage;

            var number = 0;
            _.each(vm.trade_draw_data, function(item) {
                if(item.name) {
                    number++;
                }
            });
            for(var i=0; i<vm.task_list.length; i++) {
                if(vm.task_list[i].task_code === vm.selection.task_code) {
                    vm.trade_draw_data = TradeDrawService.add(vm.selection, number, 
                        vm.state.selection.plans, vm.user.trade[0], vm.revisions.length);
                    break;
                }
            }

            var items = $filter('filter')(vm.trade_draw_data, {'task_code': vm.selection.task_code}, true);
            _.each(items, function(b) {
                b.draw = b.contract * parseFloat(vm.selection.percentage);
            })

            vm.updateDrawInput();
            console.log('in the ok section');
        }, function (value) {
            //Do something
            //$scope.new_extra = false;
            console.log('in the do something section');
        });
    };

    vm.back = function() {
        $location.state({
            'from_billing_setup': true,
        });
        $location.url('/trades/accounts/receivable');
    };

    vm.switchCalculation = function(item) {
        var items = $filter('filter')(vm.trade_draw_data, {
            'number': item.number}, true);
        var first = _.remove(items, function(b) {
            return b.show_number;
        });

        if(item.v_or_p === 'P') {
            first[0].value = 0.0;
            first[0].draw = 0;
            first[0].show_input = true;
            _.each(items, function(b) {
                b.draw = 0;
                b.show_input = true;
            });
        } else {
            first[0].value = 0.0;
            first[0].draw = 0;
            first[0].show_input = false;
            _.each(items, function(b) {
                b.draw = 0;
                b.show_input = false;
            });
        }

        vm.updateDrawInput();
    };

    vm.updateDrawPercentage = function(item) {
        console.log(item);
        console.log(vm);
        var items = $filter('filter')(vm.trade_draw_data, {'number': item.number}, true);
        _.each(items, function(b) {
            b.draw = b.contract * parseFloat(item.value);
        });
        vm.updateDrawInput();
    };

    vm.updateDrawInput = function() {
        console.log(vm);
        var draws = [];
        var item = {};
        var index_set = false;
        var idx = 0;
        _.each(vm.trade_draw_data, function(data) {
            if(data.show_number) {
                item = {
                    'show_number': data.show_number,
                    'number': data.number,
                    'name': data.name,
                    'task_code': data.task_code,
                    'v_or_p': data.v_or_p,
                    'value': data.value,
                    'revision': data.revision,
                    'plans': [{
                        'plan': data.plan,
                        'contract': data.contract,
                        'draw': data.draw,
                    }],
                }
                draws.push(item);
                index_set = false;
            } else {
                if(!index_set) {
                    idx = 0;
                    for(var i = draws.length-1; i >= 0 ; i--) {
                        if(draws[i].number === data.number) {
                            idx = i;
                            index_set = true;
                            break;
                        }
                    }
                }

                draws[idx].plans.push({
                    'number': data.number,
                    'show_number': false,
                    'plan': data.plan,
                    'contract': data.contract,
                    'draw': data.draw
                });
            }
        });

        console.log(draws);

        if(!vm.builder) {
            vm.settings = TradeDrawService.getSettings();
            vm.builder = $filter('filter')(vm.settings.builders, {
                'trade_code': vm.state.trade_code, 'company_code': vm.state.company_code }, true)[0];
        }

        if(vm.builder) {
            //now find the project or create one
            var proj = $filter('filter')(vm.builder.projects, {
                'job_code': vm.state.job_code }, true);
        } else {
            var proj = [];
        }

        if(proj.length === 1) {
            proj[0].draws = draws;
        } else {
            vm.builder.projects.push({
                'job_code': vm.state.job_code,
                'use_default_settings': true,
                'confirmed_settings': true,
                'auto_bill': false,
                'takeout_general_liability': false,
                'draws_set': true,
                'draws': draws
            });
        }

        console.log(vm.settings);

        vm.updateSettings();
    };

    vm.updateIndividualDrawInput = function(item) {
        var proj = $filter('filter')(vm.builder.projects, {'job_code': vm.project.job_code}, true)[0];
        if(proj) {
            var draw = $filter('filter')(proj.draws, {'number': item.number}, true)[0];
            if(draw) {
                var plan = $filter('filter')(draw.plans, {'plan': item.plan}, true)[0];
                if(plan) {
                    plan.draw = item.draw;
                    vm.updateSettings();
                }
            }
        }
    };

    vm.cancelUpdate = function() {
        TradeDrawService.getSettings(vm.trade_code, vm.user.contractor_code, vm.user.trade[0]).then(function(settings) {
            vm.settings = settings;
            vm.builder = $filter('filter')(settings.builders, {
                'trade_code': vm.state.trade_code, 'company_code': vm.state.company_code }, true)[0];
        });

        return false;
    };

    vm.updateSettings = function() {
        vm.settings.$update(function(success) {
            vm.settings = success;

            vm.builder = $filter('filter')(vm.settings.builders, {
                'company_code': vm.state.company_code, 'trade_code': vm.state.trade_code }, true)[0];
            vm.setCurrentProject();
            vm.trade_draw_data = TradeDrawService.getProjectDraws(vm.state.builder_name,
                vm.state.trade_code, vm.state.company_code, vm.state.job_code);
            toaster.pop('success', 'Settings Updated');
        }, function(error) {
            toaster.pop('error', 'Settings Update Error', error);
        })
    };

    vm.editDrawName = function(item) {
        item.drawNameEditing = true;
    };
    vm.updateDrawName = function(item) {
        if(!item.drawNameEditing) return;
        if(item.name == "") {
            toaster.pop('error', 'Name Error', 'Name cannot be an empty string');
            return;
        }

        var idx = vm.trade_draw_data.indexOf(item);

        if(idx !== -1) {
            if(!vm.builder) {
                vm.builder = $filter('filter')(vm.settings.builders, {
                    'company_code': vm.state.trade_code, 'trade_code': vm.state.company_code }, true)[0];
            }

            var proj = $filter('filter')(vm.builder.projects, {
                'job_code': vm.state.job_code }, true)[0];

            var draw = $filter('filter')(proj.draws, {'number': item.number}, true)[0];

            draw.name = item.name;

            vm.updateSettings();
        }

        item.drawNameEditing = false;
    };

    vm.editDrawAmount = function(item) {
        item.drawAmountEditing = true;
    };
    vm.updateDrawAmount = function(item) {
        if(!item.drawAmountEditing) return;
        item.draw = item.draw.replace(/[^.0-9 ]/g, "");
        item.draw = parseFloat(item.draw);

        if(!isNaN(item.draw)) {
            vm.updateIndividualDrawInput(item);
        } else {
            item.draw = 0.00;
            toaster.pop('error', 'Input Error', 'Expectint a dollar value');
        }
        
        item.drawAmountEditing = false;
    };

    vm.editRevision = function(item) {
        item.revisionEditing = true;
    };

    vm.doneRevisionEditing = function(item) {
        if(!item.revisionEditing) return;
        item.revision = item.revision.number;

        var revision = (item.revision == 0)?vm.revisions.length:item.revision;
        var draw = $filter('filter')(vm.current_project_settings.draws, {
            'number': item.number}, true);
        if(draw.length != 1) {
            toaster.pop('error', 'Draw Error', 'Cannot save the draw.');
            return;
        }

        draw[0].revision = item.revision;

        _.each(vm.project.plan_codes, function(plan) {
            if(plan.item != 'T&M') {
                var my_trade = $filter('filter')(plan.trade_totals, {
                    'trade': vm.user.trade[0], 'revision': revision}, true);
                if(my_trade.length == 1) {
                    var update = $filter('filter')(draw[0].plans, {
                        'plan': plan.item}, true);
                    if(update.length == 1) {
                        update[0].contract = my_trade[0].total;

                        if(item.v_or_p == "P") {
                            update[0].draw = update[0].contract * item.value;
                        }
                    }
                }
            }
        });

        vm.updateSettings();

        item.revisionEditing = false;
    };

    vm.editTaskList = function(item) {
        item.taskListEditing = true;
    };
    vm.doneTaskListEditing = function(item) {
        if(!item.taskListEditing) return;
        
        var draw = $filter('filter')(vm.current_project_settings.draws, {
            'number': item.number}, true);
        if(draw.length != 1) {
            toaster.pop('error', 'Draw Error', 'Cannot find the draw.');
            return;
        }

        draw[0].task_code = item.task_code;
        
        vm.updateSettings();

        item.taskListEditing = false;
    };

    vm.syncOptionsFromProject = function() {
        vm.current_project_settings.options = [];
        _.each(vm.project_options.options, function(option) {
            vm.current_project_settings.options.push({
                'option_id': option._id,
                'option_number': option.number,
                'option_name': option.name,
                'task_code': vm.task_list[vm.task_list.length-1].task_code
            });
        });

        vm.options_need_updating = false;
        vm.updateSettings();
    };

    vm.updateOptionSettings = function() {
        vm.updateSettings();
    };

    vm.editOptionTaskCode = function(item) {
        item.optionTaskCodeEditing = true;
    };

    vm.changeOptionTaskCode = function(item) {
        if(!item.optionTaskCodeEditing) return;
vm.updateSettings();
        //var idx = vm.current_project_settings.options.indexOf(item);
        //vm.current_project_settings.options[idx].task_code = item.task_code;

        item.optionTaskCodeEditing = false;
    };

    vm.removeDraw = function (item, index) {
        console.log(vm);
        _.remove(vm.trade_draw_data, function(draw) {
            return draw.number == item.number;
        });

        var builder = $filter('filter')(vm.settings.builders, {
            'trade_code': vm.builder.trade_code, 
            'company_code': vm.builder.company_code}, true);

        if(builder.length == 1) {
            var project = $filter('filter')(builder[0].projects, {
                'job_code': vm.current_project_settings.job_code }, true);

            if(project.length == 1) {
                _.remove(project[0].draws, function(draw) {
                    return draw.number == item.number;
                });

                _.each(project[0].draws, function(draw, idx) {
                    draw.number = idx+1;
                });

                vm.updateSettings();
            }
        }
    };

    vm.removeDrawOperation = function (item, index) {
        ngDialog.openConfirm({
            template:
                '<h2>Confirm Delete Draw</h2>' +
                '<p>This operation will remove the draw from the system</p>' +
                '<p>Are you sure you want to continue? </p>' +
                '<div>' +
                '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            // perform delete operation
            vm.removeDraw(item, index);
        }, function (value) {
            //Do something
            console.log('in the do something section of removeDrawOperation');
        });
    };

    vm.addCompanyEmail = function (newCompanyEmail) {
        if (aceUtils.isUndefinedOrNull(newCompanyEmail) || newCompanyEmail == '') return;

        vm.settings.company_emails.push(newCompanyEmail);

        vm.updateSettings();

        this.newCompanyEmail = '';
    };

    vm.viewDetails = function (index, text) {
        //this function gets called when the email modal is active
        //and sets some global variables for the edit functions
        vm.editEmailIndex = index;
        vm.editEmailText = text;
    };

    vm.acceptEditEmail = function () {
        if(vm.editEmailIndex == -1) return;

        vm.settings.company_emails[vm.editEmailIndex] = vm.editEmailText;

        vm.updateSettings();
        vm.editEmailIndex = -1;
        vm.editEmailText = null;
    };

    vm.cancelEditEmail = function () {
        vm.editEmailIndex = -1;
        vm.editEmailText = null;
    };

    vm.deleteEmail = function () {
        if(vm.editEmailIndex == -1) return;
        vm.settings.company_emails.splice(vm.editEmailIndex, 1);

        vm.updateSettings();
        vm.editEmailIndex = -1;
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/accounts-receivable/public/controllers/billingSetup.js